// Port of new arty's components/arty/community/CommunityPicker.tsx (arty repo).
// Client divergences: copy is `arty-card` `community-ask.picker.*`, and "Explore
// communities" is town-square's `/community`, built with `buildTownSquareUrl`.
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { buildTownSquareUrl } from '~/utils/index';

function Avatar({ community }: { community: any }) {
  if (community.avatarUrl) {
    return <img alt="" className="size-10 shrink-0 rounded-full object-cover" src={community.avatarUrl} />;
  }
  return (
    <span
      aria-hidden="true"
      className="flex size-10 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-semibold text-muted-foreground"
    >
      {community.name.trim().charAt(0).toUpperCase()}
    </span>
  );
}

/**
 * Step one: which community the piece goes to. Only drawn for two or more - one is
 * selected by being the only one, and none falls through to the join prompt.
 */
export function CommunityPicker({
  communities,
  loading,
  onSelect,
}: {
  communities: any[];
  loading: boolean;
  onSelect: (community: any) => void;
}) {
  const { t } = useTranslation('arty-card');

  if (loading) {
    return <p className="py-6 text-center text-sm text-muted-foreground">{t('community-ask.picker.loading')}</p>;
  }

  if (communities.length === 0) {
    return (
      <div className="flex flex-col items-start gap-3 py-2">
        <p className="text-sm text-foreground">{t('community-ask.picker.empty')}</p>
        <a
          className="inline-flex h-11 items-center rounded-full border border-border px-4 text-sm font-medium text-foreground hover:bg-muted"
          href={buildTownSquareUrl('/community')}
          rel="noreferrer"
          target="_blank"
        >
          {t('community-ask.picker.explore')}
        </a>
      </div>
    );
  }

  return (
    <ul className="-mx-1 flex max-h-[45dvh] flex-col gap-1 overflow-y-auto px-1">
      {communities.map((community) => (
        <li key={community.id}>
          <button
            className="flex min-h-14 w-full items-center gap-3 rounded-xl border border-transparent px-2 py-2 text-left hover:border-border hover:bg-muted"
            onClick={() => onSelect(community)}
            type="button"
          >
            <Avatar community={community} />
            <span className="flex-1 truncate text-sm font-medium text-foreground">{community.name}</span>
            <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
          </button>
        </li>
      ))}
    </ul>
  );
}
